// 请假状态
export const LEAVE_STATUS = {
  toBeChecked: 1, // 待审批
  agreed: 2, // 已同意
  rejected: 3, // 已拒绝
  toBeCancel: 4, // 待撤销
  canceled: 5, // 已撤销
  cancelRejected: 6, // 拒绝撤销
  invalidity: 7, // 已失效
  revoked: 8 // 已销假
}
// 请假状态对应显示文案
export const LEAVE_STATUS_TEXT = {
  1: '待审批', // 待审批
  2: '已同意', // 已同意
  3: '已拒绝', // 已拒绝
  4: '待审批', // 待撤销
  5: '已撤销', // 已撤销
  6: '已同意', // 拒绝撤销
  7: '已失效', // 已失效
  8: '已销假'
}

// 请假审批流转状态 -- 不用
export const APPROVE_STATUS = {
  apply: 1, // 发起申请
  toBeChecked: 7, // 待审批
  agreed: 2, // 已同意
  rejected: 3, // 已拒绝
  cancel: 4, // 发起撤销申请
  toBeCancel: 8, // 待撤销
  canceled: 5, // 已撤销
  cancelRejected: 6, // 拒绝撤销
  revoked: 8 // 已销假
}

// 请假审批流转状态对应文案 -- 不用
export const APPROVE_STATUS_TEXT = {
  1: '发起申请',
  7: '待审批',
  2: '已同意',
  3: '已拒绝',
  4: '发起撤销申请',
  8: '待审批',
  5: '已撤销',
  6: '撤销被拒绝'
}

// 请假类型
export const LEAVE_TYPE = {
  1: '病假',
  2: '事假'
}

// 沙盒类型
export const SANDBOX_TYPE = {
  student: 7, // 学生
  guardian: 8, // 家长
  staff: 9 // 教职工
}

// 角色
export const LEAVE_ROLE = {
  guardian: 1, // 家长
  headmaster: 2, // 班主任
  admin: 3, // 管理员
  teacher: 4, // 钉钉通讯录任课老师
  dormAdmin: 5, // 宿舍管理员
  student: 7, // 学生
  meTeacher: 8, // 德育考评老师
  ceTeacher: 9, // 班级考评老师、班级评比值周老师
  elecTeacher: 11, // 选修课老师
  seTeacher: 12, // 滞留生值周老师
  securityPolicer: 14, // 区域出警人
  securityManager: 15, // 区域负责人
  behaviorTeacher: 16, // 课堂行为巡查老师
  classrankApprover: 18, // 班级评比审批老师
  customRole: 99, // 自定义角色
  classTeacher: 100 // 大类老师角色 后台无此定义
}

// 角色名称
export const LEAVE_ROLE_NAME = {
  1: '家长',
  2: '班主任',
  3: '管理员',
  4: '任课老师', // isTeacher || isMoralEduTeacher || isClassEvaluationTeacher
  5: '宿舍管理员',
  7: '学生',
  8: '德育考评老师', // isMoralEduTeacher
  9: '班级考评老师', // isClassEvaluationTeacher
  10: '值周老师', // isScheduleTeacher
  11: '选修课老师',
  12: '滞留生值周老师',
  14: '出警人',
  15: '区域负责人',
  16: '课堂行为巡查老师', // behaviorTeacher
  99: '自定义角色',
  100: '大类老师角色'
}

// 搜索类型(Tab标签)
export const LEAVE_SEARCH_TYPE = {
  agentLeave: 1, // 代请假
  allLeave: 2 // 全部请假
}

export const WEEK = {
  0: '日',
  1: '一',
  2: '二',
  3: '三',
  4: '四',
  5: '五',
  6: '六'
}

export const WEEK_TEXT = {
  1: '一',
  2: '二',
  3: '三',
  4: '四',
  5: '五',
  6: '六',
  7: '日'
}

export const WEEK_DAY = {
  0: '周日',
  1: '周一',
  2: '周二',
  3: '周三',
  4: '周四',
  5: '周五',
  6: '周六',
  7: '周日'
}

export const WEEK_DAY_FULL = {
  0: '星期天',
  1: '星期一',
  2: '星期二',
  3: '星期三',
  4: '星期四',
  5: '星期五',
  6: '星期六'
}

// 通讯录类型
export const ADDRESS_BOOK_TYPE = {
  all: 0, // (默认值)显示全部通讯录
  org: 1, // 仅显示员工通讯录
  school: 2 // 仅显示家校通讯录
}

// 通讯录节点类型
export const NODE_TYPE = {
  dept: 1, // 部门
  member: 2, // 成员
  root: -1, // 校区列表
  campus: 0, // 学区
  period: 1, // 学段
  grade: 2, // 年级
  class: 3, // 班级
  student: 4, // 学生
  guardian: 5 // 家长
}

// 通讯录选择类型
export const SELECT_TYPE = {
  all: 0, // (默认值)所有节点都可勾选
  dept: NODE_TYPE.dept, // 仅部门
  member: NODE_TYPE.member // 仅成员
}

// 返回已选节点值类型
export const RETURN_TYPE = {
  id: 0, // 返回魔点Id(默认)
  dingId: 1, // 返回钉钉Id
  node: 2, // 返回魔点节点对象（含魔点Id）
  dingNode: 3 // 返回钉钉节点对象（含钉钉Id）
}

// 性别
export const SEX_TYPE = {
  0: '未设置',
  1: '男',
  2: '女'
}
export const SEX_TYPE_ICON = {
  0: '',
  1: '&#xe685;',
  2: '&#xe686;'
}

// 住宿类型
export const ACCMMODATION_TYPE = {
  1: '走读',
  2: '住宿',
  3: '半走读',
  4: '半住宿'
}

// 通讯录节点属性（仅限家校通讯录）
export const NODE_ATTRIBUTE = {
  school: 0, // 学校
  capmus: 1, // 学区
  period: 2, // 学段
  grade: 3, // 年级
  class: 4, // 班级
  classSubDept: 5, // 中间部门学生、家长、老师
  student: 6 // 学生
}

// 考勤状态
export const ATTENDANCE_ATATUS = [
  '无效打卡',
  '未打卡',
  '正常',
  '正常',
  '迟到',
  '早退',
  '缺勤',
  '请假'
]

// 上下学状态
export const IN_OUT_TYPE = {
  1: '上学',
  2: '下学'
}

// 正常上下学字段
export const INTERFACE_TYPE = ['', 'normalCheckInCount', 'normalCheckOutCount']

// 中文数字
export const NUM_TEXT = [
  '零',
  '一',
  '二',
  '三',
  '四',
  '五',
  '六',
  '七',
  '八',
  '九',
  '十',
  '十一',
  '十二',
  '十三',
  '十四',
  '十五',
  '十六',
  '十七',
  '十八',
  '十九',
  '二十',
  '二十一',
  '二十二',
  '二十三',
  '二十四',
  '二十五',
  '二十六',
  '二十七',
  '二十八',
  '二十九',
  '三十',
  '三十一',
  '三十二',
  '三十三',
  '三十四',
  '三十五',
  '三十六',
  '三十七',
  '三十八',
  '三十九',
  '四十',
  '四十一',
  '四十二',
  '四十三',
  '四十四',
  '四十五',
  '四十六',
  '四十七',
  '四十八',
  '四十九',
  '五十',
  '五十一',
  '五十二',
  '五十三',
  '五十四',
  '五十五',
  '五十六',
  '五十七',
  '五十八',
  '五十九',
  '六十'
]

export const INNER_CORP = [
  'ding215f16be7cb2343135c2f4657eb6378f',
  'ding7695755912aeb28035c2f4657eb6378f',
  'dingf8da6faaa4730bfff5bf40eda33b7ba0',
  'ding52baf7bf239b7686ffe93478753d9884',
  'dingd1351f194ecf283dacaaa37764f94726',
  'ding8ddc717c75bda46cf2c783f7214b6d69',
  'ding47729af11dc37275a1320dcb25e91351',
  'ding47900f8ef296f9dba1320dcb25e91351',
  'dingb32d9527f2cd7c734ac5d6980864d335',
  'dinga48ee59c9f9567c0f2c783f7214b6d69',
  'ding48a24f7c33d770c5f2c783f7214b6d69', // 杨明
  'ding350850dc26c6c330a39a90f97fcb1e09', // 贾杭春
  'ding47900f8ef296f9dba1320dcb25e91351'
]
export const DEBUGGER_CORP = ['ding215f16be7cb2343135c2f4657eb6378f']

export const DEBUGGERID = 'yanran170245620'

export const ONLINE_STATUS = ['离线', '在线']

// 设备类型
export const DEVICE_TYPE = {
  GATE: 40, // 智能人脸闸机柱(仅限用于获取所有闸机设备)
  MC1: 41, // MC1智能门禁控制盒
  MX1: 42, // MX1魔点盒子
  S3: 43, // S3智能人脸闸机柱
  S4: 45, // S4智能人脸闸机柱
  DOOR: 61, // 门禁机(仅限用于获取所有门禁设备)
  D1: 62, // D1智能人脸考勤门禁机
  D2: 63, // D2智能人脸考勤门禁机
  G2: 64, // G2智能人脸考勤门禁机
  MH2: 71, // MH2智能人脸身份自证机
  MG1: 72, // MG1智能人脸语音对讲门禁机
  MV1: 81, // MV1智能人脸访客机
  X2: 101, // MV1智能人脸访客机
  D3: 65, // D3
  Y2: 102, // Y2指纹考勤门禁机
  D2plus: 66, // D2plus智能门禁机
  MG3: 77,
  CB: 201, // 电子班牌
  CAMERA: 101,
  T1: 104, // t1班牌
  T21: 123, // t21自研班牌
  TQ1: 113, // 亲情通话机
  'T10-V': 124
}
// 设备图片映射
export const DEVICE_MODE_MAP = {
  65: 'D3',
  104: 'T1',
  113: 'TQ1',
  123: 'T21',
  124: 'T10-V',
  101: 'CAMERA'
}
export const DEVICE_TYPE_TAG = {
  40: 'GATE',
  41: 'MC1',
  42: 'MX1',
  43: 'S3',
  45: 'S4',
  62: 'D1',
  63: 'D2',
  64: 'G2',
  71: 'MH2',
  72: 'MG1',
  81: 'MV1',
  101: 'X2',
  65: 'D3',
  66: 'D2plus',
  102: 'Y2',
  77: 'MG3',
  201: 'CB' // 电子班牌
}
export const DEVICE_TYPE_TEXT = {
  40: '闸机',
  41: 'MC1智能门禁控制盒',
  42: 'MX1魔点盒子',
  43: 'S3智能人脸闸机柱',
  45: 'S4智能人脸闸机柱',
  62: 'D1智能人脸考勤门禁机',
  63: 'D2智能人脸考勤门禁机',
  64: 'G2智能人脸考勤门禁机',
  71: 'MH2智能人脸身份自证机',
  72: 'MG1智能人脸语音对讲门禁机',
  81: 'MV1智能人脸访客机',
  101: 'X2智能门禁机',
  65: 'D3',
  66: 'D2plus',
  102: 'Y2指纹考勤门禁机',
  77: 'MG3',
  201: '校园电子班牌'
}

export const WELCOME_NOTIFY = {
  1: '欢迎词',
  2: '通知'
}

export const MORAL_TIME_TYPE = {
  1: {
    icon: '&#xe682;',
    text: '学期统计'
  },
  2: {
    icon: '&#xe6b5;',
    text: '周统计'
  }
}

export const WELCOME_BG = {
  1: {
    id: 1,
    url: '/campusleave/static/img/welcome/welcome1.jpg',
    color: '#FFFDAD',
    title: '红色'
  },
  2: {
    id: 2,
    url: '/campusleave/static/img/welcome/welcome2.jpg',
    color: '#FFFFFF',
    title: '黄色'
  },
  3: {
    id: 3,
    url: '/campusleave/static/img/welcome/welcome3.jpg',
    color: '#06417E',
    title: '蓝色'
  },
  4: {
    id: 4,
    url: '/campusleave/static/img/welcome/welcome4.jpg',
    color: '#FFFFFF',
    title: '绿色'
  },
  5: {
    id: 5,
    url: '/campusleave/static/img/welcome/welcome5.jpg',
    color: '#FFFFFF',
    title: '科技'
  },
  6: {
    id: 6,
    url: '/campusleave/static/img/welcome/welcome6.jpg',
    color: '#DA4C00',
    title: '团圆'
  },
  7: {
    id: 7,
    url: '/campusleave/static/img/welcome/welcome7.jpg',
    color: '#008504',
    title: '健康'
  }
}

export const WELCOME_BG_LIST = [
  {
    header: '通用模板',
    bgs: [
      {
        id: 1,
        url: '/campusleave/static/img/welcome/welcome1.jpg',
        color: '#FFFDAD',
        title: '红色'
      },
      {
        id: 2,
        url: '/campusleave/static/img/welcome/welcome2.jpg',
        color: '#FFFFFF',
        title: '黄色'
      },
      {
        id: 3,
        url: '/campusleave/static/img/welcome/welcome3.jpg',
        color: '#06417E',
        title: '蓝色'
      },
      {
        id: 4,
        url: '/campusleave/static/img/welcome/welcome4.jpg',
        color: '#FFFFFF',
        title: '绿色'
      }
    ]
  },
  {
    header: '特色模板',
    bgs: [
      {
        id: 5,
        url: '/campusleave/static/img/welcome/welcome5.jpg',
        color: '#FFFFFF',
        title: '科技'
      },
      {
        id: 6,
        url: '/campusleave/static/img/welcome/welcome6.jpg',
        color: '#DA4C00',
        title: '团圆'
      },
      {
        id: 7,
        url: '/campusleave/static/img/welcome/welcome7.jpg',
        color: '#008504',
        title: '健康'
      }
    ]
  }
]

// 德育考评 班级评比 留言 欢迎词 通知公告 班牌管理 22, 留言单独处理
export const CLASSCARD_MODULE_IDS = [20, 21, 23, 24, 27]

/*
开通模块 1:考勤，2:请假，3: 测温，4: 宿管，5: 录脸，6: 门禁 7: 大屏 8: 弹性离校
20: 德育考评 21: 班级评比  22: 给孩子留言 23: 欢迎词 24: 通知公告 25: 亲情电话 26: 班级课表 27: 班牌管理 28: 学年学期 29: 通话模块
30: 班级放学 31: 学生留堂
41: 学生荣誉
43: 选修课
51: 智能排课
551: 测温管理 6: 门禁管理 46: 预约访客 81: 预约会议室
70: 食谱
95: 车辆管理
97: 家长接送
121: 智能传递柜
*/
export const PAGE_IN_MODULE = {
  attendance: 1, // 考勤
  leave: 2, // 请假
  temperature: 3, // 测温
  dorm: 4, // 宿管
  face: 5, // 录脸 人脸录入
  entryInformation: 5,
  facedoor: 6, // 门禁 预约访客
  screen: 7, // 大屏
  flexleave: 8, // 弹性离校
  moral: 20, // 德育考评
  classrank: 21, // 班级评比
  message: 22, // 给孩子留言
  welcome: 23, // 欢迎词
  notice: 24, // 通知公告
  familycall: 29, // 亲情电话---改为29
  schedule: 26, // 课表
  classcard: 27, // 班牌管理
  yearsemester: 28, // 学年学期
  call: 29, // 通话模块
  classover: 30, // 班级放学
  afterschool: 31, // 学生留堂
  honor: 41, // 学生荣誉
  common: -1,
  others: -1,
  system: -1,
  home: -1,
  '/': -1,
  opendoor: 161, // 进出校管理
  atschool: 162, // 在校统计
  classevaluation: 43, // 课堂评价
  elective: 44, // 选修课
  educational: 51, // 智能排课
  substitute: 52, // 调代课
  recipes: 70, // 食谱
  studentSign: 48, // 学生签到
  deviceAI: 110, // 无感设备
  vehiclemanage: 95, // 车辆管理
  // clearplate: 42 // 光盘行动 挂在班牌下面
  security: 110, // 校园安全
  antibully: 112,
  track: 113, // 一键找人
  lockdoor: 140, // 智能门锁
  behavior: 151,
  vehicleSend: 97, // 家长接送
  auth: 666,
  meal: 171, // 就餐
  rights: 301 // 权益中心
}

export const SUBSTITUTE_STATUS = {
  0: '全部状态',
  1: '待安排',
  2: '已安排',
  3: '自主安排',
  4: '教务安排',
  5: '已撤销',
  6: '已失效',
  7: '已失效',
  8: '已退回',
  9: '已结束'
}
export const SUBSTITUTE_STATUS_DATA = [
  {
    id: 0,
    text: '全部状态'
  },
  {
    id: 1,
    text: '待安排'
  },
  {
    id: 2,
    text: '已安排'
  },
  {
    id: 3,
    text: '自主安排'
  },
  {
    id: 4,
    text: '教务安排'
  },
  {
    id: 5,
    text: '已撤销'
  },
  {
    id: 6,
    text: '已失效'
  },
  {
    id: 8,
    text: '已退回'
  },
  {
    id: 9,
    text: '已结束'
  }
]
export const SUBSTITUTE_STATUS_TYPE = {
  1: '因公',
  2: '事假',
  3: '病假'
}
export const SUBSTITUTE_STATUS_TYPE_DATA = [
  {
    id: 0,
    text: '全部原因'
  },
  {
    id: 1,
    text: '因公'
  },
  {
    id: 2,
    text: '事假'
  },
  {
    id: 3,
    text: '病假'
  }
]
// 课程默认颜色
export const COURSE_COLOR = {
  语文: { border: '#FF9F00', background: '#fdf2de' },
  数学: { border: '#0089ff', background: '#deeffd' },
  英语: { border: '#00b853', background: '#def5e9' },
  科学: { border: '#1e0ce8', background: '#dcd9fd' },
  体育: { border: '#b810da', background: '#f9e0fe' },
  音乐: { border: '#468a9c', background: '#dfeaed' },
  美术: { border: '#f47c84', background: '#f4d9db' }
}

// 常见菜类型
export const COMMON_DISHES_CLASSIFY = {
  1: { type: 1, name: '主食', count: 0 },
  2: { type: 2, name: '肉类', count: 0 },
  3: { type: 3, name: '素食', count: 0 },
  4: { type: 4, name: '汤羹', count: 1 },
  5: { type: 5, name: '小吃', count: 1 },
  6: { type: 6, name: '饮品', count: 1 },
  7: { type: 7, name: '水果', count: 1 },
  8: { type: 99, name: '其它', count: 1 }
}

export const COMMON_DISHES_SEGMENT = [
  {
    mealType: 1,
    mealName: '早餐',
    checked: false
  },
  {
    mealType: 2,
    mealName: '早点',
    checked: false
  },
  {
    mealType: 3,
    mealName: '午餐',
    checked: true
  },
  {
    mealType: 4,
    mealName: '午点',
    checked: false
  },
  {
    mealType: 5,
    mealName: '晚餐',
    checked: false
  }
]

export const COMMON_RESET_COMMIT = [
  {
    key: 'attendanceMainDate',
    value: ''
  },
  {
    key: 'attendanceMainDepts',
    value: ''
  },
  {
    key: 'attendanceMainDept',
    value: null
  },
  {
    key: 'studentInfo',
    value: null
  },
  {
    key: 'calendarTime',
    value: null
  },
  {
    key: 'isCalendarForm',
    value: null
  },
  {
    key: 'inOutType',
    value: null
  },
  {
    key: 'dormState',
    value: null
  },
  {
    key: 'isSandboxPrepared',
    value: false
  },
  {
    key: 'moralTimeType',
    value: 1
  },
  {
    key: 'weekNow',
    value: -1
  },
  {
    key: 'weekList',
    value: null
  },
  {
    key: 'classMoralClass',
    value: null
  },
  {
    key: 'classDing',
    value: {}
  },
  {
    key: 'classEvaluationTab',
    value: 0
  },
  {
    key: 'classEvaluationDingId',
    value: ''
  },
  {
    key: 'setAttendanceQueryFilter',
    value: null
  },
  {
    key: 'setAttendanceSelectDetailNodes',
    value: null
  },
  {
    key: 'setIsCustomNotification',
    value: null
  },
  {
    key: 'dishSegmentList',
    value: []
  },
  {
    key: 'dishDetail',
    value: {}
  },
  {
    key: 'selectedDish',
    value: {}
  },
  {
    key: 'dishFilter',
    value: null
  },
  {
    key: 'isEditDish',
    value: 0
  },
  {
    key: 'mealType',
    value: -1
  },
  {
    key: 'setFilterCondition',
    value: null
  },
  {
    key: 'setCurrentTabId',
    value: null
  },
  {
    key: 'dashActiveIndex',
    value: -1
  },
  {
    key: 'activeTabIndex',
    value: null
  },
  {
    key: 'cacheObject',
    value: null
  },
  {
    key: 'applicationStatus',
    value: null
  },
  {
    key: 'reasonType',
    value: null
  },
  {
    key: 'setClassCardModeCache',
    value: null
  },
  {
    key: 'setFaceSandBoxId',
    value: ''
  },
  {
    key: 'setStudentSandBoxId',
    value: ''
  },
  {
    key: 'setGuardianSandBoxId',
    value: ''
  },
  {
    key: 'orgSandboxId',
    value: ''
  },
  {
    key: 'setLeaveStatisticsDate',
    value: ''
  },

  {
    key: 'setCustomTemplateCampusId',
    value: ''
  },
  {
    key: 'setDeviceModel',
    value: ''
  },
  {
    key: 'setCustomTemplateInfo',
    value: ''
  },
  {
    key: 'setCustomDeviceName',
    value: ''
  },
  {
    key: 'setClassicTemplateInfo',
    value: ''
  },
  {
    key: 'setClassicModeSelectedClass',
    value: ''
  },
  {
    key: 'setCustomPadTemplateId',
    value: ''
  },
  {
    key: 'setBehaviorDate',
    value: null
  },
  {
    key: 'setBehaviorDateRange',
    value: null
  },
  {
    key: 'setBehaviorClass',
    value: null
  },
  {
    key: 'setNoticeRoleList',
    value: []
  }
]

export const ROOT_PATH = '/home'
export const TAB_ROLE_ID = 'TAB_ROLE_ID'
export const TOP_ROLE_ID = 'TOP_ROLE_ID'
export const MODULE_ROLE_TYPE = 'MODULE_ROLE_TYPE'

export const ATTENDANCE_GUARDIAN = [
  { id: 5, eq: 'neq', name: '出勤', countText: 'checkInDayCount' },
  { id: 3, eq: 'eq', name: '迟到', countText: 'lateTimes' },
  {
    id: 0,
    eq: 'eq',
    name: '未打卡',
    countText: 'lackCheckInTimes'
  },
  { id: 6, eq: 'eq', name: '请假', countText: 'leaveCount' }
]
export const IN_OUT_TYPE_DATA = {
  1: [
    {
      id: 3,
      name: '迟到',
      countText: 'lateMemberCount'
    },
    {
      id: 8,
      name: '未打卡',
      countText: 'schoolBlankMemberCount'
    },
    {
      id: 6,
      name: '请假',
      countText: 'leaveCheckInCount'
    }
  ],
  2: [
    {
      id: 7,
      name: '未打卡',
      countText: 'homeBlankMemberCount'
    },
    {
      id: 6,
      name: '请假',
      countText: 'leaveCheckOutCount'
    }
  ]
}

export const ROLE_REPLACE_TYPE = {
  all: 1, // 可以全部替换
  portion: 2, // 部分替换
  unable: 3, // 不能替换
  optional: 4 // 替换与否均可
}

// 请假返校状态
export const BACK_SCHOOL_STATUS = {
  1: { content: '未上传', color: 'rgba(23,26,29,0.4)' },
  2: { content: '审批中', color: 'rgba(255,146,0,1)' },
  3: { content: '已通过', color: 'rgba(0,184,83,1)' },
  4: { content: '已拒绝', color: 'rgba(255,82,25,1)' },
  5: { content: '已失效', color: 'rgba(23,26,29,0.4)' }
}

export const CLASS_PAD_TYPE = {
  portraitScreen: 70007
}

// 账号绑定类型
export const ACCOUNT_BIND_TYPE = {
  dingUid: 1, // 钉钉UID
  userName: 2, // 用户名
  mobile: 4, // 手机号码
  email: 8, // 邮箱
  idCert: 16, // 身份证
  aliyunIonUid: 32, // 阿里云IOT用户Id
  alipay: 64, // 支付宝账号
  alipayUid: 128, // 支付宝UID
  weixin: 256, // 微信账号
  weixinUid: 512, // 微信UID
  qq: 1024 // QQ号码
}
// 可以开启红外识别的设备
export const SWITCH_IN_FRARED = [DEVICE_TYPE['T10-V'], DEVICE_TYPE.T21]
// 亲情通话机设备
export const FAMILY_CALL_FRARED = [DEVICE_TYPE.TQ1, DEVICE_TYPE['T10-V']]

// 套餐提示语
export const SKU_TIP = {
  // 沿用套餐
  // 免费版: [],
  // 试用版: [],
  // 旗舰版: [],
  // 新增套餐
  精选版: [
    '学生考勤，到离校家长通知;<br>',
    '学生请假及关联门禁通行权限;<br>',
    '选修课学生选课及课程签到;<br>'
  ],
  放学管理功能: [
    '班级放学消息推送及大屏展示;<br>',
    '学生留堂管理及消息推送;<br>',
    '滞留生托管消息推送及家长到校通知;<br>'
  ],
  德育功能: [
    '学生德育考评及考评结果统计查询;<br>',
    '班级评比录入及评比结果统计查询;<br>',
    '学生课堂评价录入及评价结果统计查询;<br>'
  ],
  电子班牌功能: [
    '今日课表、班级通知等班级校园文化展示;<br>',
    '德育考评、光盘行动等学生个人表现记录;<br>',
    '亲情通话、亲情留言等家校沟通功能;<br>'
  ],
  宿舍管理功能: ['学生归离寝统计;<br>', '宿管大屏归离寝数据展示;<br>'],
  校园防疫功能: [
    '设备端查询健康码、核酸结果信息;<br>',
    '健康码、核酸结果信息统计查询;<br>',
    '健康码、核酸结果异常通知管理员及班主任;<br>'
  ]
  // 亲情通话功能: [],
  // 停车管理功能: [],
  // 局端大屏: [],
  // 旧套餐
  // 基础版: [],
  // 高级版: [],
  // 教务包: [],
  // 德育包: [],
  // 电子班牌包: [],
  // 宿舍管理包: [],
  // 出入校管理包: [],
  // 校园防疫包: [],
  // 测温小助手: [],
  // '魔方-学生进出包': [],
  // '魔方-智慧防疫包': [],
  // 重庆防疫包: []
  // 魔方宿管包: [],
}

export const MODE_CONFIG = [
  {
    text: '班牌模式',
    value: 1,
    module: 27, // 亲情通话机不支持班牌模式 可以写死27
    imageClass: 'bpmode'
  },
  {
    text: '宿舍模式',
    value: 3,
    module: 4,
    imageClass: 'ssmode'
  },
  {
    text: '通话模式',
    value: 2,
    module: 29,
    imageClass: 'thmode'
  },
  {
    text: '自定义模式',
    value: 4,
    module: 27,
    imageClass: 'custommode'
  }
]
// 需要tabbar的路由
export const TABBAR_ROUTER_CONFIG = [
  '/attendance/index',
  '/attendance/pageAttendanceMonth',
  '/attendance/setting',
  '/dorm/index',
  '/dorm/setting',
  '/afterschool/index',
  '/afterschool/setting',
  '/flexleave/index',
  '/flexleave/setting',
  '/recipes/adminDaily',
  '/recipes/setting',
  '/classcard/familycall/list',
  '/classcard/familycall/setting',
  '/classcard/familycall/mechine',
  '/classevaluation/index',
  '/classevaluation/setting',
  '/schedule/student',
  '/schedule/student/setting',
  '/antibully/event',
  '/antibully/setting',
  '/security/overview',
  '/security/events',
  '/security/setting',
  '/behavior/index',
  '/behavior/stastic',
  '/classcard/classrankall',
  '/classcard/classrank/approval',
  '/classcard/classrank/setting',
  '/meal/index',
  '/meal/setting',
  '/leave/index',
  '/leave/setting'
]

export const ACCOUNT_TYPE_TEXT = {
  WECHAT: '微信'
}

// 防欺凌报警方式
export const ALARM_TYPES = [
  {
    value: '1',
    label: '一键报警'
  },
  {
    value: '2',
    label: '音频报警'
  }
]
export const ALARM_TYPES_MAP = ALARM_TYPES.reduce((obj, item) => {
  obj[item.value] = item.label
  return obj
}, {})
// 防欺凌事件状态
export const ALARM_STATES = [
  {
    value: '100',
    label: '未处理'
  },
  {
    value: '201',
    label: '未出警'
  },
  {
    value: '202',
    label: '已出警'
  },
  {
    value: '901',
    label: '已处理'
  },
  {
    value: '902',
    label: '误报'
  },
  {
    value: '903',
    label: '无需处理'
  }
]
export const ALARM_STATES_MAP = ALARM_STATES.reduce((obj, item) => {
  obj[item.value] = item.label
  return obj
}, {})
// 防欺凌出警人状态
export const ALARM_EXECUTE_TYPES = [
  {
    value: '1',
    label: '未出警'
  },
  {
    value: '2',
    label: '已出警'
  }
]
export const ALARM_EXECUTE_TYPES_MAP = ALARM_EXECUTE_TYPES.reduce(
  (obj, item) => {
    obj[item.value] = item.label
    return obj
  },
  {}
)
// 防欺凌现场状态
export const ALARM_EVENT_SITUATIONS = [
  {
    value: '0',
    label: '现场无人'
  },
  {
    value: '1',
    label: '现场制止'
  },
  {
    value: '2',
    label: '误报'
  },
  {
    value: '3',
    label: '无需出警'
  }
]
export const ALARM_EVENT_SITUATIONS_MAP = ALARM_EVENT_SITUATIONS.reduce(
  (obj, item) => {
    obj[item.value] = item.label
    return obj
  },
  {}
)
// 触发方式
export const TRIGGER_TYPE = [
  {
    value: '1',
    label: '无感识别'
  },
  {
    value: '2',
    label: '音频报警'
  },
  {
    value: '3',
    label: '一键报警'
  }
]

export const BULLY_EVENT_ID = 999
export const TRIGGER_TYPE_MAP = TRIGGER_TYPE.reduce((obj, item) => {
  obj[item.value] = item.label
  return obj
}, {})

export const ALERT_COLOR = {
  999: '#1970a2', // 欺凌事件
  1000: '#FF9200', // 周界入侵
  1001: '#006AFE', // 吸烟
  1002: '#00B042', // 翻越
  1003: '#2F4827', // 打电话
  1004: '#79062E', // 玩手机
  1005: '#F4C800', // 跌倒
  1006: '#FF5219', // 打架
  1008: '#EC4589', // 可疑徘徊
  1009: '#B963D3', // 人员聚集
  1010: '#9A3F0B', // 脱岗
  1011: '#247A52', // 火灾
  1012: '#568747', // 明厨亮灶（垃圾桶未盖、老鼠检测）
  1013: '#5972C8', // 重点人员布控
  1014: '#74AEFF', // 奔跑
  1015: '#1B4E96', // 追逐
  1016: '#5AC8FA', // 跨线
  1017: '#B654DB', // 猫鼠检测
  1018: '#BF6EA0', // 备用
  1019: '#8998BC', // 备用
  1020: '#ED6861', // 备用
  1021: '#E87A3D', // 备用
  1022: '#41B6EC', // 备用
  1023: '#B0A77A', // 备用
  1024: '#DF973F', // 备用
  1025: '#C5ABA9', // 备用
  1026: '#DEA48C', // 备用
  1027: '#71C6E8', // 备用
  1028: '#FE8D92', // 备用
  1029: '#DCB844', // 备用
  1030: '#27ECC1', // 备用
  1031: '#E1BCB6', // 备用
  1032: '#D7D2AD', // 备用
  1033: '#95F4E9', // 备用
  1034: '#D7DFDE', // 备用
  1035: '#DBE3BD', // 备用
  1036: '#DFEDAA', // 备用
  1037: '#BDF6D8', // 备用
  1038: '#D7EDF2', // 备用
  1039: '#EBFC98' // 备用
}

// 未处理 & 处理中的饼图颜色
export const UNPROCESSED_SAFETY_COLORS_OTHER = ['#FF5219', '#FF9200', '#5AC8FA']
// 已处理的饼图颜色
export const PROCESSED_SAFETY_COLORS_OTHER = [
  '#00B042',
  '#FF5219',
  '#A2A3A4',
  '#FF9200'
]

// 未处理 & 处理中 饼图数据
export const UNPROCESSED_SERIES = {
  notProcessed: '未处理',
  notExecute: '未出警',
  executed: '已出警'
}

// 已处理 饼图数据
export const PROCESSED_SERIES = {
  timelyCount: '及时处理',
  notTimelyCount: '未及时处理',
  unnecessaryExecuteCount: '无需处理',
  falseAlertCount: '误报'
}

// 报警事件上报音视频类型
export const ALARM_REPORTING_TYPE = {
  IMAGE: 1, // 原始图片
  VIDEO: 2, // 视频
  AUDIO: 3, // 音频
  FACE_IMAGE: 4, // 头像抠图
  COMBINED_IMAGE: 5, // 合成图片
  DING_AUDIO: 6 // 钉钉 云盘 音频
}

export const SEX_TAG = {
  tagId: 'sex',
  tagName: '性别',
  tagType: 2, // 2 不可修改
  tagOptionList: [
    {
      tagOptionId: '1',
      tagOptionName: '男'
    },
    {
      tagOptionId: '2',
      tagOptionName: '女'
    }
  ]
}
